import { Action } from 'redux'

import { Scan } from 'src/lib/interfaces/Scan.interface'
import { ScansByEmployee } from 'src/lib/interfaces/ScansByEmployee.interface'
import { BaseReportFilterParameters } from 'src/lib/interfaces/BaseReportFilterParameters.interface'

export const actionTypes = {
  // fetch scans list
  SCANS_FETCH_LIST: 'SCANS_FETCH_LIST',
  SCANS_FETCH_LIST_FAILED: 'SCANS_FETCH_LIST_FAILED',
  SCANS_FETCH_LIST_SUCCESS: 'SCANS_FETCH_LIST_SUCCESS',

  SCANS_FETCH_LIST_BY_EMPLOYEE: 'SCANS_FETCH_LIST_BY_EMPLOYEE',
  SCANS_FETCH_LIST_BY_EMPLOYEE_FAILED: 'SCANS_FETCH_LIST_BY_EMPLOYEE_FAILED',
  SCANS_FETCH_LIST_BY_EMPLOYEE_SUCCESS: 'SCANS_FETCH_LIST_BY_EMPLOYEE_SUCCESS',

  // filter params
  SCANS_SET_FILTER_PARAMS: 'SCANS_SET_FILTER_PARAMS',
  SCANS_FILTER_PARAMS_RESET: 'SCANS_FILTER_PARAMS_RESET'
}

/**
 * Fetch scans list
 */
export interface ScansFetchListAction extends Action {
  payload: {
    next?: (err?: any, scans?: Scan[]) => void
  }
}

export const fetchScansList = (next?: (err?: any, scans?: Scan[]) => void): ScansFetchListAction => ({
  type: actionTypes.SCANS_FETCH_LIST,
  payload: { next }
})

// Success
export interface ScansFetchListSuccessAction extends Action {
  payload: {
    scans: Scan[]
  }
}

export const fetchScansListSuccess = (scans: Scan[]): ScansFetchListSuccessAction => ({
  type: actionTypes.SCANS_FETCH_LIST_SUCCESS,
  payload: { scans }
})


// Error
export interface ScansFetchListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchScansListError = (errorMessage: string): ScansFetchListErrorAction => ({
  type: actionTypes.SCANS_FETCH_LIST_FAILED,
  payload: {
    errorMessage
  }
})

/**
 * Fetch scans list by employee
 */
export interface ScansFetchListByEmployeeAction extends Action {
  payload: {
    next?: (err?: any, scans?: ScansByEmployee[]) => void
  }
}

export const fetchScansListByEmployee = (next?: (err?: any, scans?: ScansByEmployee[]) => void): ScansFetchListByEmployeeAction => ({
  type: actionTypes.SCANS_FETCH_LIST_BY_EMPLOYEE,
  payload: { next }
})

// Success
export interface ScansFetchListByEmployeeSuccessAction extends Action {
  payload: {
    scans: ScansByEmployee[]
  }
}

export const fetchScansListByEmployeeSuccess = (scans: ScansByEmployee[]): ScansFetchListByEmployeeSuccessAction => ({
  type: actionTypes.SCANS_FETCH_LIST_BY_EMPLOYEE_SUCCESS,
  payload: { scans }
})

// Error
export interface ScansFetchListByEmployeeErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchScansListByEmployeeError = (errorMessage?: string): ScansFetchListByEmployeeErrorAction => ({
  type: actionTypes.SCANS_FETCH_LIST_BY_EMPLOYEE_FAILED,
  payload: { errorMessage }
})

/**
 * Reset filter params
 */
export interface ScansFilterParamsResetAction extends Action {
  payload: {
    filterParams?: BaseReportFilterParameters
  }
}

export const resetScansFilterParams = (filterParams?: BaseReportFilterParameters): ScansFilterParamsResetAction => ({
  type: actionTypes.SCANS_FILTER_PARAMS_RESET,
  payload: { filterParams }
})

/**
 * Update filter
 */
export interface ScansSetFilterParamsAction extends Action {
  payload: {
    filterParams: BaseReportFilterParameters
  }
}

export const setScansFilterParams = (filterParams: BaseReportFilterParameters): ScansSetFilterParamsAction => ({
  type: actionTypes.SCANS_SET_FILTER_PARAMS,
  payload: { filterParams }
})

export type ActionTypes =
  ScansFetchListAction |
  ScansFetchListSuccessAction |
  ScansFetchListErrorAction |
  ScansFilterParamsResetAction |
  ScansSetFilterParamsAction |
  ScansFetchListByEmployeeAction |
  ScansFetchListByEmployeeSuccessAction |
  ScansFetchListByEmployeeErrorAction



// WEBPACK FOOTER //
// ./src/store/scans/actions.ts